var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-layout__inner w-100",attrs:{"id":"question-create"}},[_c('div',{staticClass:"row w-100"},[_c('div',{staticClass:"section col-md-12"},[_c('QuestionCreateComponent',{on:{"update-test":_vm.updateHeading}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }